<rid-mechanic-background />

<rid-mechanic-wrapper>
  <rid-top-bar class="block w-full" name="Games | Memory" [steps]="pairs().length" [progress]="completedPairs().length" />

  <rid-mechanic-content>
    <rid-mechanic-title title="Vind alle paren" />

    <div
      class="mt-18 grid gap-4 lg:gap-6"
      animate.leave="anim-fade-out"
      [style.grid-template-columns]="'repeat(' + columnCount() + ', minmax(0, 1fr))'"
    >
      @for (card of cards(); track card.cardId) {
        <div class="aspect-7/5 w-44 lg:w-60" animate.enter="anim-pop-in">
          <rid-memory-card
            class="h-full w-full"
            [text]="card.content.type === 'TEXT' ? card.content.text : undefined"
            [image]="card.content.type === 'IMAGE' ? card.content.image : undefined"
            [audio]="card.content.type === 'AUDIO' ? card.content.audio : undefined"
            [state]="cardState(card)"
            [isClickable]="!isChecking() && cardState(card) === 'HIDDEN'"
            (clicked)="flip(card)"
            (feedbackAnimEnd)="onFeedbackAnimEnd()"
          />
        </div>
      }
    </div>

    <!-- feedback overlay -->
    <rid-overlay-feedback #overlayFeedback />
  </rid-mechanic-content>
</rid-mechanic-wrapper>
